// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewsInfo_root__3bfet","new":"ReviewsInfo_new__3knkK","averageRating":"ReviewsInfo_averageRating__2qRui","iconStar":"ReviewsInfo_iconStar__nujJw"};